const listAttributes = [
  'subject',
  'videoId',
  'topic',
  'youtubeId',
  'playbackProvider',
  'topicResources',
  'title',
  'description',
  'creationDatetime',
  'resources',
  'topicVideos',
  'relatedVideos',
  'pathLabels',
  'host',
] as const;

/**
 * The list is readable by any signed-in user, so the provider's own identifier
 * is kept to the single-video read the permission check guards.
 */
const getAttributes = [...listAttributes, 'gumletAssetId'] as const;

const searchAttributes = ['title'] as const;

const updateAttributes = [
  'title',
  'description',
  'host',
  'youtubeId',
  'relatedVideos',
  'resources',
] as const;

/**
 * What a Gumlet source replacement writes. `playbackProvider` is in the list so
 * the encoder sees a whole source, not a bare asset ID.
 */
const sourceAttributes = ['playbackProvider', 'gumletAssetId'] as const;

export const VideoAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Search: searchAttributes,
  Update: updateAttributes,
  Source: sourceAttributes,
};
